









































import { Component, Vue, Watch } from "vue-property-decorator";
import { RevistasService, PaginaRevista } from "@/services/revistas.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { fileToBase64 } from "@/shared/utils/utils";
import { required } from "@/shared/validators";

@Component({
  components: {
    Loading,
    Modal,
  },
})
export default class AlterarImagemPaginaRevista extends Vue {
  paginaRevista: PaginaRevista | null = null;
  arquivoImagem: File | null = null;
  valid = false;
  loading = false;

  rules = {
    imagem: [required()],
  };

  required = (v: unknown) => {
    return !!v || "Campo obrigatório";
  };

  @Watch("arquivoImagem")
  onArquivoChange() {
    if (this.paginaRevista) {
      this.paginaRevista.imagemCompleta = URL.createObjectURL(
        this.arquivoImagem
      );
    }
  }

  async salvarPaginaRevista() {
    this.loading = true;
    const form = this.$refs.form as any;

    if (form.validate() && this.arquivoImagem && this.paginaRevista) {
      const base64 = await fileToBase64(this.arquivoImagem);
      await RevistasService.alterarImagemPaginaRevista(
        this.paginaRevista,
        base64
      );
      this.fechar();
    }
    this.loading = false;
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async alterarImagemPaginaRevista(
    idRevista: string,
    idPaginaRevista: string
  ) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.loading = true;
    this.paginaRevista = await RevistasService.obterPaginaRevista(
      idRevista,
      idPaginaRevista
    );
    this.loading = false;

    return p;
  }
}
